<div>

  <loading id="qualificationsLoader" styling="pageloading-primary" [initialLoading]="true"></loading>

  @if (filteredQualifications$ | async; as qualifications) {
    @if (isArrayAndNotEmpty(qualifications)) {
      <div class="mb-4 flex  items-top mobile:flex-col ">
        <div class="pr-4 py-2 font-medium flex-shrink-0">
          Filter qualifications by:
        </div>
        <div>
          <mat-chip-listbox multiple>
            @for (filter of filters; track filter) {
              <mat-chip-option
                class="cursor-pointer"
                [selected]="filter.status"
                (click)="toggleFilter(filter.list_qualification_type_id)">
                {{ filter.qualification_type }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      </div>
      <div class="">
        @for (iq of qualifications ?? []; track iq) {
          <div (click)="toggleQualSelected(iq)" class="bg-white cursor-pointer hover:bg-gray-50 flex items-center px-6 border-b py-3 ">
            <div class="flex items-center justify-center w-32 mobile:w-10 flex-shrink-0 overflow-visible">
              @if (qualIsSelected(iq.institution_qualification_id)) {
                <mat-icon class="text-gwc-blue-500 mobile:text-xl">check_circle</mat-icon>
              }
              @if (expansionPanelHover === iq.institution_qualification_id) {
                <mat-icon class="text-gwc-bg-gray-light mobile:text-xl">check_circle</mat-icon>
              }
            </div>
            <div>
              {{ iq.qualification.qualification }}
              @if (iq.qualification_level_id) {
                ({{ iq.qualification_level.list_qualification_level?.qualification_level}})
              }
            </div>
          </div>
        }
      </div>
    }
  }


</div>